import { Yup } from 'src/helpers/Yup';
import { onlyDigits } from 'src/helpers/string';
import { passwordRules } from 'src/components/UI/Input/PasswordWithValidation';
import { type AccessDataValues } from '../types';

export interface AccessDataForm extends AccessDataValues {
  isPasswordValid: boolean;
}

const isStrongPassword = (password: string): boolean => {
  return passwordRules.every((rule) => rule.validator(password));
};

export const AccessDataSchema = Yup.object().shape({
  cellphoneNumber: Yup.string()
    .required('Informe um número de celular válido.')
    .test('validate phoneNumber', 'Informe um número de celular válido.', function (cellphoneNumber) {
      if (!cellphoneNumber) return false;
      const digits = onlyDigits(cellphoneNumber);
      return digits.length === 11;
    }),
  email: Yup.string().email('Informe um email válido.').required('Informe um email válido.'),
  password: Yup.string()
    .required('Informe uma senha válida.')
    .min(8, 'Critérios para criação de senha não atendidos')
    .max(16, 'Sua senha deve ter no máximo 16 caracteres')
    .test('validate password', 'Critérios para criação de senha não atendidos', function (_, context): boolean {
      return context.parent.isPasswordValid;
    }),
  isPasswordValid: Yup.bool().required(),
});

export { isStrongPassword };
